<template>
  <a-modal :footer="false" :open="isOpen" title="" @cancel="close">
    <div class="py-5">{{ desc }}</div>
    <div class="flex justify-evenly gap-10">
      <SubmitButton
        @click="handleYesFunc"
        :val="'Yes'"
        :loading="this.loading"
      />
      <SubmitButton
        @click="close"
        class="bg-red-500"
        :val="'No'"
        :loading="false"
      />
    </div>
  </a-modal>
</template>

<script>
//services
import authService from "@/services/auth-service.js";

//libraries
import { useToast } from "vue-toastification";

//components
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";

export default {
  name: "LogoutModal",
  props: ["isOpen", "handleYes", "close", "loading", "desc"],
  components: {
    SubmitButton,
  },
  data() {
    return {
      toast: useToast(),
    };
  },
  methods: {
    handleYesFunc() {
      console.log("lciked in confirm");
      this.handleYes();
    },
  },
};
</script>

<style></style>
